import { PhoneOutgoing } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const PhoneArrowUpRightIcon = createLucideIcon(PhoneOutgoing);
